var exports = {
  "vU": "App.module__appContainer___TXRiUz",
  "lq": "App.module__overlayScope___TXRiUz",
  "u$": "App.module__skipLink___TXRiUz",
  "pq": "App.module__quickSwitcherPortal___TXRiUz",
};

module.exports = exports;
